import { Box, Button } from "@mui/material";
import React from "react";
import { FaCheck } from "react-icons/fa";
import { keyframes } from "@emotion/react";

// Create a pulse animation
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
`;

const AddToTargetBtn = ({ onClick }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          fontSize: "1rem",
          fontWeight: "bold",
          background: "linear-gradient(45deg, #1976d2 30%, #2196f3 90%)",
          "&:hover": {
            background: "linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)",
            transform: "translateY(-2px)",
          },
          animation: `${pulse} 2s infinite`,
          transition: "all 0.3s ease",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          position: "relative",
          overflow: "hidden",
          "&:after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.2)",
            transform: "translateX(-100%)",
            transition: "transform 0.6s ease",
          },
          "&:hover:after": {
            transform: "translateX(100%)",
          },
        }}
        startIcon={<FaCheck style={{ transform: "scale(1.2)" }} />}
      >
        Confirm Audience Selection
      </Button>
    </Box>
  );
};

export default AddToTargetBtn;
